const DEFAULT_LANDING_BASE_URL = 'https://landing.miglioriamo.com';

function resolveLandingBaseUrl(): string {
  const viteValue =
    typeof import.meta !== 'undefined' ? (import.meta as { env?: Record<string, string> }).env?.VITE_LANDING_BASE_URL : undefined;
  const craValue =
    typeof process !== 'undefined' && process.env ? process.env.REACT_APP_LANDING_BASE_URL : undefined;

  const raw = (viteValue || craValue || '').toString().trim();
  const base = raw || DEFAULT_LANDING_BASE_URL;
  return base.replace(/\/+$/, '');
}

export const LANDING_PUBLIC_BASE_URL = resolveLandingBaseUrl();

export const buildLandingPublicUrl = (slug?: string | null) => {
  const safeSlug = (slug || '').trim().replace(/^\/+/, '');
  if (!safeSlug) {
    return LANDING_PUBLIC_BASE_URL;
  }
  return `${LANDING_PUBLIC_BASE_URL}/${safeSlug}`;
};
